import React from "react";
import CartProducts from "./CartProducts";
import TotalPrice from "./TotalPrice";

const Cart = () => {
  return (
    <div className='col-span-12 sm:col-span-12 md:col-span-5 lg:col-span-4 xxl:col-span-4'>
      <CartProducts />

      <TotalPrice />
    </div>
  );
};

export default Cart;
